import { jsPDF } from "jspdf";
import moment from "moment";
import 'jspdf-autotable'

const lightGray = [245, 245, 245];
const white = [255, 255, 255];

const price = '36';
const mainColor = [68, 160, 255];

export const downloadInvoice = (user, payment) => {
    const doc = new jsPDF();

    const invoiceNumber = payment.id.slice(-8);
    const orderNumber = user.id.slice(-8);

    let descriptionTitle = 'Abonnement mensuel à la palteforme';
    if (parseInt(payment.amount) <= 100) descriptionTitle = 'Conversion de fichier à prix réduit + période d\'essai 48H à l\'abonnement';

    const vatRate = user.metadata.vatNumber ? 0 : 20;
    const amount = payment.isRefund ? payment.amount * -1 : payment.amount;
    const priceHT = Number(amount / ((100 + vatRate) / 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',')
    const priceTVA = Number((amount / 100) - (amount / ((100 + vatRate) / 100) / 100)).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',');
    const priceTTC = Number((amount / 100)).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',');


    doc.setFontSize(14);
    doc.text('CONVERTISSEUR', 10, 10);
    doc.text(`Facture n° CONVERT_FR_${invoiceNumber}`, 200, 10, { align: 'right' });

    doc.setFontSize(8);
    doc.text(`E-mail: ${user.email}`, 10, 20);
    doc.text(`Date: ${moment(payment.createdAt).format('DD/MM/YYYY')}`, 200, 20, { align: 'right' });

    const userInfo = [['E-mail :', user.email]]

    if (user.metadata.reason) userInfo.push(['Entreprise :', user.metadata.reason])
    if (user.metadata.address) userInfo.push(['Adresse :', user.metadata.address])
    if (user.metadata.vatNumber) userInfo.push(['TVA :', user.metadata.vatNumber])

    userInfo.push(['Numéro de commande :', orderNumber])

    doc.autoTable({
        startY: 25,
        margin: { left: 10 },
        tableWidth: 100,
        styles: { fontSize: 8, fillColor: lightGray },
        head: [[{ content: 'Client', colSpan: 2, styles: { fillColor: mainColor } }]],
        body: userInfo,
    })

    doc.autoTable({
        startY: 25,
        margin: { left: 120 },
        tableWidth: 80,
        styles: { fontSize: 8, fillColor: lightGray },
        head: [[{ content: 'Date échéance', styles: { fillColor: mainColor } }, { content: 'Mode de règlement', styles: { fillColor: mainColor } }]],
        body: [['À réception', 'Carte Bancaire']],
    })

    doc.autoTable({
        startY: user.metadata.reason ? 80 : 60,
        margin: { left: 10 },
        tableWidth: 190,
        head: [[
            { content: 'Désignation', colSpan: 3, styles: { fillColor: mainColor, halign: 'center' } },
            { content: 'Montant HT', colSpan: 2, styles: { fillColor: mainColor, halign: 'center' } }
        ]],
        body: [
            [
                { content: descriptionTitle, colSpan: 3, styles: { fillColor: white, fontStyle: 'bold' } },
                { content: `${priceHT} €`, colSpan: 2, styles: { fillColor: white, halign: 'right' } },
            ],
            [
                { content: `Abonnement mensuel avec tacite reconduction à la plateforme, moyennant ${price}€ TTC par mois. Offre sans engagement de durée, résiliable à tout moment sans justificatifs. Accès illimité à : conversion et compressions de fichiers (documents, musiques, vidéos, polices, ebooks, présentations etc.), plus de 25 000 formats supportés, cloud 100% sécurisé pour stocker tous vos fichier & assistance technique téléphonique, e-mail et chat 6/7 jours.`, colSpan: 3 }
            ],
            [
                { content: 'Date de création du compte :', styles: { fillColor: white } },
                { content: moment(user.createdAt).format('DD/MM/YYYY'), styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
            ],
            [
                { content: 'Adresse IP :', styles: { fillColor: white } },
                { content: user.metadata.ip, styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
            ],
            [
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: 'Total HT', styles: { fillColor: white } },
                { content: `${priceHT} €`, styles: { fillColor: white, halign: 'right' } },
            ],
            [
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: `TVA : ${vatRate}%`, styles: { fillColor: white } },
                { content: `${priceTVA} €`, styles: { fillColor: white, halign: 'right' } },
            ],
            [
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: 'Total TTC', styles: { fillColor: white, fontStyle: 'bold' } },
                { content: `${priceTTC} €`, styles: { fillColor: white, halign: 'right', fontStyle: 'bold' } },
            ],
            [
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
                { content: '', styles: { fillColor: white } },
            ],
            [
                { content: 'Aucun escompte ne sera pratiqué en cas de paiement anticipé.', colSpan: 3, styles: { fontSize: 6, fillColor: white } },
                { content: 'Net à payer :', styles: { fillColor: lightGray, fontStyle: 'bold' } },
                { content: `${priceTTC} €`, styles: { fillColor: lightGray, halign: 'right', fontStyle: 'bold' } },
            ],
        ],
    })

    doc.setFontSize(7);
    doc.text(doc.splitTextToSize('Tout retard de paiement fera courir de plein droit des pénalités de retard, après mise en demeure préalable écrite restée infructueuse, égale à trois (3) fois le taux d\'intérêt légal calculé sur le montant HT des sommes restant dues, et ce à compter de la date d\'échéance. Application d\'une indemnité pour frais de recouvrement d\'un montant de 40.00 €.', 120), 10, 180);

    doc.line(10, 200, 200, 200);
    doc.setTextColor(200, 200, 200);
    doc.text('Responsive Web Limited. 20-22 Wenlock Road, London, England, N1 7GU', 100, 205, { align: 'center' })
    doc.text('Registry Number: 09574048 - VAT Number: GB262798169', 100, 210, { align: 'center' })

    doc.save(`${invoiceNumber}.pdf`);
}

